import payment from "@/api/payment";

export default {
  state: {
  },
  mutations: {
  },
  actions: {
    async createSubscription(context, { token }) {
      const params = {
        card_id: token,
        account_id: await context.dispatch("showAccountID"),
        user_id: await context.dispatch("showUserId"),
        user_name: await context.dispatch("showUsername"),
      };
      const ret = await payment.insert(params);
      return ret;
    },
    async deleteSubscription(context) {
      const params = {
        account_id: await context.dispatch("showAccountID"),
        user_id: await context.dispatch("showUserId"),
        user_name: await context.dispatch("showUsername"),
      };
      const ret = await payment.del(params);
      return ret;
    },
    async showCard(context) {
      let params = {
        account_id: await context.dispatch("showAccountID"),
        user_id: await context.dispatch("showUserId"),
      }
      let res = await payment.show(params);
      if (res.data) {
        return res.data.data;
      }
      else {
        return {};
      }
    },
    async updateCard(context, { token }) {
      const params = {
        card_id: token,
        account_id: await context.dispatch("showAccountID"),
        user_id: await context.dispatch("showUserId"),
        user_name: await context.dispatch("showUsername"),
      };
      const ret = await payment.update(params);
      return ret;
    },
  },
  getters: {
  }
};
